module.exports = __webpack_public_path__ + "img/Amaranth-Bold.a25adb7c.svg";